import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate } from 'react-router';
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from '@mui/icons-material/Delete';
import ProjectData from "../ProjectData";
import SideBar from "../pages/sidebar/ManagerSideBar";
import DashBoardNavbar from "../pages/navbar/DashBoardNavbar";
import CreateSeller from "../Modals/CreateSeller";
import DeleteMany from "../Modals/DeleteMany";
import JSON from "../Modals/JSON";
import FileUploadIcon from '@mui/icons-material/FileUpload';
import { showSuccessToast, showErrorToast } from "../../Utils/toastUtils";
// import Loading from "../pages/Loading";

const ManagerDashboard = () => {

  // navigations and permisions
  const userType = sessionStorage.getItem('role') === "Viewer"
  let navigate = useNavigate();

  //helpers
  const [user, setuser] = useState("");
  const [deleteArray2, setDeleteArray2] = useState([])

  const [isCheckedArray, setIsCheckedArray] = useState([]);
  const [data, setData] = useState([])
  const [modal, setModal] = useState(false);
  const [modal3, setModal3] = useState(false);
  const [modal4, setModal4] = useState(false);
  // const [isLoading, setIsLoading] = useState(false);
  const [isProcessing, setIsProcessing] = React.useState(false);

  const handleCheckboxChange = (id) => {
    if (deleteArray2.includes(id)) {
      const newArray = deleteArray2.filter((item) => item !== id);
      setDeleteArray2(newArray)

    } else {
      const tmpArr = [...deleteArray2, id]
      setDeleteArray2(tmpArr)

    }
  };

  const submitJSON = () => {
    setIsProcessing(true)
    console.log("Started uploading json")

    let data = axios.get('/api/makejson', {
      headers: {
        Authorization: 'Bearer ' + sessionStorage.getItem('userToken')
      }
    })
      .then(response => {

        showSuccessToast((response.data && response.data.Message) ? response.data.Message : "Success")
        setIsProcessing(false)

      })
      .catch(error => {
        // Handle error
        showErrorToast("Error in Making JSON");
        setIsProcessing(false)

        console.error(error);
      });
    setIsProcessing(false)

    console.log("Ending uploading json")

  }

  const handleDelete = (id) => {
    let data = axios.delete(`/api/sellers/`, { id: [id] }, {
      headers: {
        Authorization: 'Bearer ' + sessionStorage.getItem('userToken')
      }
    })
      .then(response => {
        // Handle successful response
        showSuccessToast((response.data && response.data.Message) ? response.data.Message : "Success")
        getData();

      })
      .catch(error => {
        // Handle error
        showErrorToast("Error")

        console.error(error);
      });

  }
  const getData = () => {

    let data = axios.get('/api/sellers/all', {
      headers: {
        Authorization: 'Bearer ' + sessionStorage.getItem('userToken')
      }
    })
      .then(response => {

        // Handle successful response
        setData(response.data)
      })
      .catch(error => {
        // Handle error
        console.error(error);

      });

  }

  const clearArrays = () => {
    setDeleteArray2([])
  }

  const getDeleteArray = () => {
    return deleteArray2;
  }

  const logOut = () => {
    sessionStorage.clear();
    // navigate('../')
    navigate("../login", { replace: true });
  }

  return (

    <body
      className="g-sidenav-show overflow-hidden bg-gray-200"
      style={{ overflow: "hidden" }}
    >
      <div style={{ float: "right", marginTop: "50px", marginRight: "20px" }}>

      </div>
      {/* side navbar */}
      <SideBar logOut={logOut} />
      {/* --------------------------------------------------------------------------------------- */}
      {/* // top Navbar */}
      <main className="main-content position-relative max-height-vh-100 h-100 border-radius-lg ">
        {/* Navbar */}
        <DashBoardNavbar user={user} />
        <div>
          <ProjectData
            data={data}
            handleDelete={handleDelete}
            getData={getData}
            handleCheckboxChange={handleCheckboxChange}
            isCheckedArray={isCheckedArray}
            deleteArray2={deleteArray2}


          // searchHandle={searchHandle}
          />
        </div>


        {!userType && (<CreateSeller
          getData={getData}
          modal={modal}
          setModal={setModal}
        />)
        }
        {!userType && (<DeleteMany
          getData={getData}
          data={deleteArray2}
          modal={modal4}
          setModal={setModal4}
          getDeleteArray={getDeleteArray}
          clearArrays={clearArrays}
        />)
        }
        {!userType && (<JSON
          getData={getData}
          modal={modal3}
          setModal={setModal3}
        />)
        }
        <div
          style={{
            float: "right",
            marginRight: "20px",
            paddingTop: "15px",
          }}
        >

          {!userType && (
            <div
              className="fixed-bottom d-flex justify-content-end px-3"
              style={{
                position: "fixed",
                bottom: 0,
                left: 0,
                right: 0,
                zIndex: 9999,
                padding: "10px"
              }}>
              <button
                type="button"
                // onClick={submitJSON}
                onClick={() =>setModal3(!modal3)}
                className="btn btn-success px-4 "
                disabled={isProcessing}
              >
                {!isProcessing && <FileUploadIcon />}
                {isProcessing ? (
                  // <p className="d-flex flex-row" >
                  <span>Processing</span>
                  // </p>
                ) : (
                  'Make JSON'
                )}
              </button>
              <button
                className="btn btn-info mx-4"
                disabled={deleteArray2.length === 0}
                style={{ float: "left" }}
                onClick={() => setModal4(!modal4)}


              >
                <DeleteIcon /> Delete Many
              </button>

              <button
                className="btn btn-info  mr-4"
                onClick={() => setModal(!modal)}
                style={{ float: "left" }}

              >
                <AddIcon /> Add Seller
              </button>
            </div>)
          }
        </div>


        {/* End Navbar */}
      </main>

    </body >

  )
}


export default ManagerDashboard;